import { useDockRightSlot } from 'components/DraggablePanel/context/DockRightSlotContext';

import useBackdropInsets from './hooks/useBackdropInsets';

import type IBackdropInsets from './interfaces/IBackdropInsets';

/**
 * Fits the modal backdrop to the page's main content, beside the docked AI chat.
 *
 * Rendered by the page layout inside `DockRightSlotProvider`, which holds the dock the AI chat
 * docks into.
 */
function BackdropInsets({ main }: IBackdropInsets): null {
  useBackdropInsets(main, useDockRightSlot());

  return null;
}

export default BackdropInsets;
